import api from "./api";

const listarArquivosPorPasta = async (IDPasta) => {
    try {
        const response = await api.get(`/arquivoByIDPasta/${IDPasta}`);
        return response.data;
    } catch (error) {
        console.error('Falha ao listar arquivos por pasta', error);
        throw error;
    }
};

const atualizarSituacaoArquivo = async (IDArquivo, situacao) => {
    try {
        const response = await api.put(`/arquivo/${IDArquivo}/situacao`, { situacao });
        return response;
    } catch (error) {
        console.error('Falha ao atualizar situação do arquivo', error);
        throw error;
    }
};

const renomearArquivo = async (IDArquivo, nome) => {
    try {
        const response = await api.put(`/arquivo/${IDArquivo}/renomear`, { nome });
        return response;
    } catch (error) {
        console.error('Falha ao renomear o arquivo', error);
        throw error;
    }
};

export const arquivoService = {
    listarArquivosPorPasta,
    atualizarSituacaoArquivo,
    renomearArquivo
};
